import { render, staticRenderFns } from "./PublicAddressBookView.vue?vue&type=template&id=b7e1b600"
import script from "./PublicAddressBookView.ts?vue&type=script&lang=ts&external"
export * from "./PublicAddressBookView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports